import * as Preact from "preact"
import Dev from "@frog/source/models/dev/Dev.js"
import * as ProcGen from "@frog/source/models/dev/Generation.js"

import "@frog/source/views/dev/DevScriptImporterScreen.less"

export default class DevScriptImporterScreen {
    render() {
        return (
            <div class="DevScriptImporterScreen">
                <title>Frog</title>
                <div class="Header" onClick={this.onScriptImportClick}>
                    Script Importer
                </div>
                <div class="Split-halves">
                    <div class="Inputs">
                        <div class="Button" onClick={this.onScriptImportClick}>
                            Load Script
                        </div>
                        <div class="SeparatorInput">
                            <div class="Label">Game</div>
                            <input class="Value" key="GameSeparator" type="text"
                                defaultValue={Dev.scriptImportSeparatorStrings.game.trim()}
                                onKeyDown={this.onKeyDown} onChange={this.onChange("game")}/>
                        </div>
                        <div class="SeparatorInput">
                            <div class="Label">Chapter</div>
                            <input class="Value" key="ChapterSeparator" type="text"
                                defaultValue={Dev.scriptImportSeparatorStrings.chapter.trim()}
                                onKeyDown={this.onKeyDown} onChange={this.onChange("chapter")}/>
                        </div>
                        <div class="SeparatorInput">
                            <div class="Label">Encounter</div>
                            <input class="Value" key="EncounterSeparator" type="text"
                                defaultValue={Dev.scriptImportSeparatorStrings.encounter.trim()}
                                onKeyDown={this.onKeyDown} onChange={this.onChange("encounter")}/>
                        </div>
                        <div class="SeparatorInput">
                            <div class="Label">Condition</div>
                            <input class="Value" key="ConditionSeparator" type="text"
                                defaultValue={Dev.scriptImportSeparatorStrings.condition.trim()}
                                onKeyDown={this.onKeyDown} onChange={this.onChange("condition")}/>
                        </div>
                        <div class="SeparatorInput">
                            <div class="Label">Comment</div>
                            <input class="Value" key="CommentSeparator" type="text"
                                defaultValue={Dev.scriptImportSeparatorStrings.comment.trim()}
                                onKeyDown={this.onKeyDown} onChange={this.onChange("comment")}/>
                        </div>
                        <div class="Export">
                            <div class="Button" onClick={this.onGenerationClick}>
                                Generate Files
                            </div>
                            <div class="Option">
                                <div class="Label">Overwrite Files?</div>
                                <input class="Check" onClick={() => this.isOverwriting = !this.isOverwriting}type="checkbox"/>
                            </div>
                        </div>
                    </div>
                    {this.parserPreview}
                </div>
            </div>
        )
    }
    onChange(segment) {
        return (event) => {
            Dev.scriptImportSeparatorStrings[segment] = event.target.value.trim() + " "
            if(Dev.importedGameScript != undefined) {
                Dev.parsedGameScript = ProcGen.parseGamescript(Dev.importedGameScript)
            }
        }
    }
    get onKeyDown() {
        return (event) => {
            event.stopPropagation()
        }
    }
    get onGenerationClick() {
        return async () => {
            ProcGen.generateGameBoilerplate(Dev.parsedGameScript, {"overwriteExisting": this.isOverwriting})
            Dev.notification = {
                "message": "Boilerplate game generated to files",
                "startTime": Date.now(),
            }
        }
    }
    get onScriptImportClick() {
        return async () => {
            let filePointer = await window.showOpenFilePicker({
                types: [
                    {
                        description: "Script to import",
                        accept: {
                            "text/*": [".md"],
                        },
                    },
                ],
                excludeAcceptAllOption: true,
                multiple: false,
            })
            filePointer = filePointer[0]
            const file = await filePointer.getFile()
            Dev.importedGameScript = await file.text()
            Dev.parsedGameScript = ProcGen.parseGamescript(Dev.importedGameScript)
        }
    }
    get parserPreview() {
        if(Dev.importedGameScript == undefined) {
            return (
                <div class="ParsePreview">
                    load script to preview
                </div>
            )
        }
        // const separators = Dev.scriptImportSeparatorStrings
        // const reactKey = "ParsePreview_Chapter:" + separators.chapter + "_Encounter:" + separators.encounter + "_Condition:" + separators.condition + "_Comment:" + separators.comment
        return (
            <div class="ParsePreview">
                {Dev.parsedGameScript.parsedLines.map((parsedLine) => {
                    return (
                        <div class={parsedLine.class} isUncaught={parsedLine.isUncaught}>
                            {parsedLine.line}
                        </div>
                    )
                })}
            </div>
        )
    }
}
